/* NICEMESS - OP-077 (2026-08-21)
   Nicemess NO tiene recogida en tienda: ninguna ubicacion tiene
   localPickupSettingsV2 configurado (verificado por la Admin API).

   El <pickup-availability> original de Dawn pedia
   /variants/{id}/?section_id=pickup-availability en CADA carga de ficha de
   producto. Esa peticion nunca podia devolver nada util, y cuando fallaba
   pintaba "No se pudo cargar la disponibilidad de retiro" con un boton
   "Actualizar" en una tienda que no ofrece recogida.

   Los dos custom elements se dejan DEFINIDOS pero inertes en vez de borrarlos:
   asi cualquier codigo del tema que haga querySelector('pickup-availability')
   sigue encontrando un elemento con .update() y no revienta.

   PARA REVERTIR (si algun dia se activa click & collect): restaurar este
   fichero desde Dawn y configurar la recogida en Configuracion > Ubicaciones.
*/

if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      connectedCallback() {
        // Vacia el <template> con el mensaje de error y se quita de en medio.
        this.innerHTML = '';
        this.removeAttribute('available');
        this.style.display = 'none';
      }

      // No-ops: product-info.js llama a update() al cambiar de variante.
      fetchAvailability() {}
      onClickRefreshList() {}
      update() {}
      renderError() {}
      renderPreview() {}
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      connectedCallback() {
        this.remove();
      }

      hide() {}
      show() {}
    }
  );
}
